// @flow
/** @jsx jsx */

import { PaymentMethodImage } from '@zapier/payment';
import { Text } from '@zapier/common-components';
import { jsx } from '@emotion/core';

import { paymentSourceMethods } from '../../types';

import type { PaymentDetailsPaypal } from '@zapier/payment/src/types';
import { type Node } from 'react';

type ChildrenProps = {
  /** Paypal Payment source details */
  paypal: PaymentDetailsPaypal,
};

type Props = {
  ...$Exact<ChildrenProps>,
  children?: ChildrenProps => Node,
  /** Show compact version of info */
  isCompact?: boolean,
};

const detailsCss = {
  marginLeft: 15,
};

const wrapperCss = {
  alignItems: 'center',
  display: 'flex',
};

const renderDefaultInfo = ({ paypal }: ChildrenProps) => (
  <Text type="body-strong">{paypal.email}</Text>
);

const renderCompactInfo = ({ paypal }: ChildrenProps) => (
  <Text color="steel" type="body">
    {paypal.email}
  </Text>
);

const PaypalInfo = ({
  isCompact = false,
  children = isCompact ? renderCompactInfo : renderDefaultInfo,
  ...props
}: Props) => (
  <div css={wrapperCss}>
    <PaymentMethodImage
      imageType={paymentSourceMethods.paypal}
      isSmall={isCompact}
    />
    <div css={detailsCss}>{children(props)}</div>
  </div>
);

export default PaypalInfo;
